import DefaultImage from '../assets/images/error-media.svg'

export default function SomethingWentWrong({ errorTitle = "Something Went Wrong", ErrorImg, children }) {

  return (
    <div className="tw-h-screen tw-overflow-auto tw-py-9 tw-px-4 md:tw-px-12 tw-bg-[#FAFAFC]">
      <div className="tw-flex tw-flex-col   sm:tw-gap-8 tw-gap-5 tw-items-center">
        <img src={ErrorImg || DefaultImage}
          className="sm:tw-w-64   tw-w-52    tw-p-2 tw-box-content tw-flex tw-justify-center tw-items-center   tw-rounded-md"
        />
        <div className="sm:tw-w-1/3   tw-text-center tw-flex tw-flex-col sm:tw-gap-7  tw-gap-3">
          <h3 className="sm:tw-text-[32px]  tw-text-2xl  ">{errorTitle}</h3>
          {
            children
          }
        </div>
      </div>
    </div>
  );
}
